import { env } from '../../lib/env/env';

export const tpfSupplierApiConfig = {
  TPF_SUPPLIER_API_BASE_URL: env.getString('TPF_SUPPLIER_API_BASE_URL') || 'http://localhost:8081',
};
